import type { ReactElement } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { handlePremiumSalesAccessRedirectWithTracking } from "app/common/utils/handleGainAccessRedirect";
import { AssetsService } from "app/services/AssetsService";

import { IMAGE_BY_VARIANT } from "../../constants/images";
import type { OverlayHookVariant } from "../../types/types";

import { StyledOverlayHook } from "./styles";

export interface IOverlayHookProps {
    className?: string;
    trackingEventName: string;
    variant: OverlayHookVariant;
    title: string;
    subTitle?: string;
    imageSrc?: string;
    imageWidth?: number;
    height?: number;
}

const OverlayHook = ({
    variant,
    title,
    subTitle,
    height,
    imageSrc,
    imageWidth,
    className,
    trackingEventName,
}: IOverlayHookProps): ReactElement => {
    const isHorizontal = variant === "horizontal";
    const imageByVariant = IMAGE_BY_VARIANT[variant];

    const handleTrialClick = () => {
        handlePremiumSalesAccessRedirectWithTracking(trackingEventName);
    };

    return (
        <StyledOverlayHook
            className={className}
            variant={variant}
            height={height}
        >
            <img
                src={AssetsService.assetUrl(imageSrc || imageByVariant.src)}
                width={imageWidth || imageByVariant.width}
                alt="Gain access"
            />

            <Flex
                flexDirection="column"
                alignItems={isHorizontal ? "flex-start" : "center"}
                gap="24px"
            >
                <Flex
                    flexDirection="column"
                    gap={isHorizontal ? "12px" : "8px"}
                >
                    <Text
                        fontVariant="h5"
                        color={colorsPalettes.carbon[400]}
                        textAlign={isHorizontal ? "left" : "center"}
                        data-automation="overlay-hook-title"
                    >
                        {title}
                    </Text>
                    {subTitle ? (
                        <Text
                            fontVariant="input2"
                            color={colorsPalettes.carbon[400]}
                            textAlign={isHorizontal ? "left" : "center"}
                            data-automation="overlay-hook-subtitle"
                        >
                            {subTitle}
                        </Text>
                    ) : null}
                </Flex>

                <div>
                    <IconButton
                        type="trial"
                        iconName="sparkles-gray"
                        iconSize="xs"
                        onClick={handleTrialClick}
                        data-automation="overlay-hook-upgrade-button"
                    >
                        {translate("si.common.upgrade")}
                    </IconButton>
                </div>
            </Flex>
        </StyledOverlayHook>
    );
};

export default OverlayHook;
